import styles from "./InfoItem.module.css";
import PropTypes from "prop-types";

/**
 * 
 * Used to display information on cards
 * 
 */

export function InfoItem({ label, description}) {
  return (
    <div className={styles.container}>
     <div className={styles.label}>
     {label}
     </div>
     <div className={styles.description}>
     {description}
    </div>
    </div>
  );
}

InfoItem.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
};
